import { render } from "./ErrorView.vue?vue&type=template&id=3f86607e&scoped=true"
const script = {}

import "./ErrorView.vue?vue&type=style&index=0&id=3f86607e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f86607e"]])

export default __exports__